<template>
  <div class="top_title">{{ $t('common.noticeandnews') }}</div>
  <div v-if="notifyList&&notifyList.length>0">
    <el-scrollbar ref="scrollbarRef" @scroll="handleScroll">
      <div class="item_box_inner" v-loading="isLoading">
        <div v-for="item in notifyList" class="item" :key="item.id">
          <NotifyCard :item="item"></NotifyCard>
        </div>
      </div>
    </el-scrollbar>
  </div>
  <div v-else>
    <div class="item_box">
      <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import {emptyUrl} from "@/utils/statusParams";
import {queryNoticeList} from "@/api/home";
import {ElMessage} from "element-plus";
import {debouncePlus} from "@/utils/mylodash";
import NotifyCard from "@/views/Study/components/NotifyCard.vue";
import {useStore} from "vuex";

const store = useStore()
const pageNo = computed(() => store.state.message.notifyListSetting.pageNo);
const totalPages = computed(() => store.state.message.notifyListSetting.totalPages)
const pageSize = computed(() => store.state.message.notifyListSetting.pageSize);
const notifyList = computed(() => store.state.message.notifyList)
const isLoading = ref(false)
const isCurrent = computed(() => store.state.message.notifyListSetting.isCurrent);


const queryNoticeListApis = async () => {
  try {
    isLoading.value = true
    await store.dispatch('message/queryNoticeListApis', {isCurrent: isCurrent.value})
    isLoading.value = false
  } catch (e) {
    isLoading.value = false
  }
}

onMounted(async () => {
  await queryNoticeListApis()
})


const scrollbarRef = ref(null)

const handleScroll = debouncePlus(async () => {
  const wrapEl = scrollbarRef.value?.wrapRef
  if (!wrapEl) return;

  const {scrollTop, scrollHeight, clientHeight} = wrapEl;
  const isBottom = scrollTop + clientHeight >= scrollHeight - 5;

  if (isBottom && !isLoading.value && pageNo.value < totalPages.value) {
    isLoading.value = true;
    const res = pageNo.value + 1;
    await store.commit("message/setNotifyListSetting", {type: "pageNo", value: res});
    await store.commit("message/setNotifyListSetting", {type: "isCurrent", value: true})
    await queryNoticeListApis();
  }
}, 200);
</script>

<style lang="less" scoped>
.top_title {
  font-size: 20px;
  font-weight: 500;
  color: #333;
  padding: 10px 20px;
}

.item_box {
  padding: 0 8px;
}

.item_box_inner {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 一行三列，每列等宽 */
  gap: 15px; /* 可选：设置列间距和行间距 */
  padding: 15px;


  .item {
    //border-bottom: 1px solid #e8e8e8;
    display: flex;
    justify-content: flex-start;

    .left {
      display: flex;
      align-items: center;
    }

    .right {
      margin: 14px 10px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;

      .tops {
        font-size: 16px;
        font-weight: bold;
      }

      .content {
        overflow-wrap: break-word;
        margin-top: 5px;
        font-size: 14px;
        font-weight: 400;
        color: #999;
      }
    }
  }
}

:deep(.el-scrollbar) {
  height: calc(100vh - 115px);
}

:deep(.el-empty__image img) {
  width: 54% !important;
}

:deep(.el-empty__description) {
  margin-top: 6px;
}

</style>